import { useEventDispatcher } from "@otto-ec/otto-components-utils/use/event-dispatcher";
import { untrack } from "svelte";
import { events, sheet } from "../index.js";
import type { Events } from "../SheetV1.types.js";
import type { NexusEvents } from "./event.nexus.js";
import type { DetailBase, BeforeOpen } from "./event.detail.js";
import type { EventAnyDefintion, GetEventPayload } from "./event.utils.js";
import { stack } from "../stack/stack.global.svelte.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const dispatchSheetEvent = <E extends EventAnyDefintion>(
  event: E,
  instance: NoInfer<GetEventPayload<E>["instance"]>,
  payload: Omit<GetEventPayload<E>, "instance" | "extraData" | "id" | "cancel"> & { id?: string },
): boolean => {
  /*                                                           */
  const dispatchDom = instance ? useEventDispatcher<Events>(instance) : null;
  /*                                                              */
  const results = [] as (boolean | undefined)[];

  /*                                                              */
  const detail: DetailBase & BeforeOpen = payload as never;
  const instanceOrNull = instance as HTMLOcSheetV1Element | null;

  /*                                                */
  detail.instance = instance;
  /*                                                          */
  detail.extraData = instanceOrNull?.extraData ?? null;

  /*                                          */
  /*                                           */
  Object.defineProperty(detail, "cancel", {
    value: () => void results.push(false),
    writable: false,
    enumerable: true,
    configurable: false,
  });

  /*                                                                          */
  if (instanceOrNull?.id) detail.id = instanceOrNull?.id;

  /*                                 */
  const [apiEvent, domEvent] = event;

  /*                                   */
  events[apiEvent].dispatch(detail as never);
  results.push(dispatchDom?.(domEvent, detail as never));

  /*                                                           */
  /*                                                                                                   */
  /*                                                                               */
  const legacy = untrack(() => stack.contentChange) ? event[3] : event[2];

  /*                                     */
  legacy.forEach(([apiAlias, domAlias]) => {
    if (domAlias) results.push(dispatchDom?.(domAlias as never, detail as never));
    if (apiAlias) {
      /*          */
      events[apiAlias as keyof NexusEvents].dispatch(detail as never);
      /*               */
      (sheet[`${apiAlias}Event` as never] as NexusEvents[keyof NexusEvents]).dispatch(
        detail as never,
      );
    }
  });

  /*                                                           */
  return results.filter((r) => typeof r === "boolean").every((result) => result);
};
